export const salonInfo = {
  name: "REFINE MEN'S SPA",
  tagline: "洗練された時間を、あなたに",
  subTagline: "プロフェッショナルによる本格メンズエステ",
  phone: "03-1234-5678",
  address: "東京都渋谷区神南1-2-3 リファインビル3F",
  hours: "11:00 〜 22:00（最終受付 21:00）",
  closedDay: "不定休",
  seats: "完全個室 5室",
  instagram: "https://www.instagram.com/",
  line: "https://line.me/",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7477369358!2d139.6980!3d35.6595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca6e8f0d4b1%3A0x1234567890abcdef!2z5riL6LC35Yy65riL6LC3!5e0!3m2!1sja!2sjp!4v1234567890",
};

export const navItems = [
  { label: "メニュー", href: "#menu" },
  { label: "こだわり", href: "#features" },
  { label: "アクセス", href: "#access" },
  { label: "ご予約", href: "#cta" },
];

export const menuItems = [
  {
    id: 1,
    name: "フェイシャルケア",
    description: "毛穴の汚れを丁寧に取り除き、肌本来のハリと透明感を引き出すフェイシャルトリートメント。",
    price: "¥12,000",
    duration: "60分",
    image: "https://readdy.ai/api/search-image?query=close%20up%20men%20facial%20skincare%20treatment%20in%20luxury%20spa%2C%20therapist%20applying%20serum%20on%20male%20face%2C%20warm%20amber%20candlelight%2C%20dark%20stone%20background%2C%20white%20towel%2C%20gold%20accent%20details%2C%20premium%20esthetic%20salon%2C%20cinematic%20moody%20lighting%2C%20high-end%20beauty%20care%2C%20professional%20skincare&width=600&height=400&seq=facial-care-menu-2024-01&orientation=landscape",
  },
  {
    id: 2,
    name: "ボディリラクゼーション",
    description: "全身の筋肉の緊張をほぐし、日常の疲れをリセットするボディトリートメント。",
    price: "¥18,000",
    duration: "90分",
    image: "https://readdy.ai/api/search-image?query=luxury%20men%20full%20body%20massage%20treatment%20table%20with%20white%20linen%2C%20therapist%20hands%20on%20back%2C%20dim%20warm%20amber%20oil%20lamp%20lighting%2C%20dark%20wooden%20spa%20interior%2C%20aromatic%20candles%2C%20premium%20wellness%20center%2C%20deep%20relaxation%20atmosphere%2C%20cinematic%20dark%20tones%2C%20high-end%20body%20treatment&width=600&height=400&seq=body-relax-menu-2024-02&orientation=landscape",
  },
  {
    id: 3,
    name: "スカルプケア",
    description: "頭皮環境を整え、頭部のコリをほぐすヘッドスパ。心地よい眠りへと誘います。",
    price: "¥8,000",
    duration: "45分",
    image: "https://readdy.ai/api/search-image?query=men%20head%20scalp%20spa%20treatment%2C%20professional%20hands%20massaging%20male%20scalp%2C%20luxury%20salon%20reclining%20chair%2C%20soft%20warm%20indirect%20lighting%2C%20dark%20elegant%20interior%2C%20premium%20hair%20care%20products%20on%20marble%20shelf%2C%20serene%20relaxing%20atmosphere%2C%20high-end%20japanese%20spa%2C%20head%20massage&width=600&height=400&seq=scalp-care-menu-2024-03&orientation=landscape",
  },
  {
    id: 4,
    name: "アイブロウデザイン",
    description: "顔の印象を左右する眉を、骨格に合わせて丁寧に整えるプロフェッショナルケア。",
    price: "¥5,500",
    duration: "30分",
    image: "https://readdy.ai/api/search-image?query=men%20eyebrow%20shaping%20grooming%20close%20up%2C%20professional%20tweezers%20and%20tools%20on%20dark%20marble%20surface%2C%20warm%20golden%20accent%20lighting%2C%20luxury%20beauty%20salon%20setting%2C%20minimalist%20japanese%20aesthetic%2C%20high-end%20grooming%20tools%20laid%20out%20elegantly%2C%20moody%20dark%20background%2C%20eyebrow%20design&width=600&height=400&seq=eyebrow-design-menu-2024-04&orientation=landscape",
  },
  {
    id: 5,
    name: "プレミアムコース",
    description: "フェイシャル・ボディ・スカルプを組み合わせた、全身トータルケアのフルコース。",
    price: "¥32,000",
    duration: "150分",
    image: "https://readdy.ai/api/search-image?query=ultra%20premium%20private%20spa%20suite%20interior%2C%20dark%20charcoal%20stone%20walls%2C%20white%20marble%20floor%2C%20warm%20amber%20candle%20glow%2C%20luxury%20treatment%20bed%20with%20crisp%20white%20linen%2C%20gold%20accent%20fixtures%2C%20minimalist%20japanese%20zen%20design%2C%20exclusive%20high-end%20wellness%20room%2C%20cinematic%20wide%20shot%2C%20premium%20spa&width=600&height=400&seq=premium-course-menu-2024-05&orientation=landscape",
  },
];

export const features = [
  {
    number: "01",
    title: "完全個室プライベート空間",
    description:
      "全室完全個室制。他のお客様と顔を合わせることなく、プライバシーを守られた空間でゆっくりとお過ごしいただけます。",
  },
  {
    number: "02",
    title: "経験豊富なセラピスト",
    description:
      "国家資格を持つセラピストが担当。お客様の状態に合わせたオーダーメイドの施術をご提供します。",
  },
  {
    number: "03",
    title: "厳選されたスキンケア製品",
    description:
      "肌への負担を最小限に抑えた、厳選されたオーガニック系製品のみを使用。施術後の肌状態を大切にしています。",
  },
];
